import { OrganizationSettingDM } from "./organization_setting_dm";
import { OrganizationStructureLabelDM } from "./organization_structure_label_dm";
import { UserDetailDM } from "./user_detail_dm";

export class LoginDM {
  constructor({
    token = "",
    user_details = {},
    organization_settings = {},
    has_point_categories = false,
    has_discount_categories = false,
    organization_logo = "",
    organization_chat = "",
    organization_theme_color = "",
    auth_provider = "",
    has_grade_permission = "",
    organization_structure_label = [],
    organization_pwa_settings = {
      features: 1,
      redirect: 1,
      show_main_menu: true,
    },
    pwa_token = "",
  }) {
    this.token = token;
    this.user_details = user_details;
    this.organization_settings = organization_settings;
    this.has_point_categories = has_point_categories;
    this.has_discount_categories = has_discount_categories;
    this.organization_logo = organization_logo;
    this.organization_chat = organization_chat;
    this.organization_theme_color = organization_theme_color;
    this.auth_provider = auth_provider;
    this.has_grade_permission = has_grade_permission;
    this.organization_structure_label = organization_structure_label;
    this.organization_pwa_settings = organization_pwa_settings;
    this.pwa_token = pwa_token;
  }

  static fromJson(json) {
    let loginDM = new LoginDM({
      token: json["token"],
      user_details: UserDetailDM.fromJson(json["user_details"]),
      organization_settings: OrganizationSettingDM.fromJson(
        json["organization_settings"]
      ),
      has_point_categories: json["has_point_categories"],
      has_discount_categories: json["has_discount_categories"],
      organization_logo: json["organization_logo"],
      organization_chat: json["organization_chat"],
      organization_theme_color: json["organization_theme_color"],
      auth_provider: json["auth_provider"],
      has_grade_permission: json["has_grade_permission"],
      organization_structure_label: [],
      organization_pwa_settings: json["organization_pwa_settings"],
      pwa_token: json["pwa_token"],
    });
    let osls = json["organization_structure_label"];
    if (Array.isArray(osls)) {
      loginDM.organization_structure_label = [];
      osls.forEach((osl) => {
        loginDM.organization_structure_label.push(
          OrganizationStructureLabelDM.fromJson(osl)
        );
      });
    }

    return loginDM;
  }
}
